/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultVideoTutorial } from '../models/api-response-paged-result-video-tutorial';
import { ApiResponseVideoTutorial } from '../models/api-response-video-tutorial';
import { createVideoTutorial } from '../fn/video-tutorial-api/create-video-tutorial';
import { CreateVideoTutorial$Params } from '../fn/video-tutorial-api/create-video-tutorial';
import { deleteVideoTutorial } from '../fn/video-tutorial-api/delete-video-tutorial';
import { DeleteVideoTutorial$Params } from '../fn/video-tutorial-api/delete-video-tutorial';
import { getListVideoTutorial } from '../fn/video-tutorial-api/get-list-video-tutorial';
import { GetListVideoTutorial$Params } from '../fn/video-tutorial-api/get-list-video-tutorial';
import { updateVideoTutorial } from '../fn/video-tutorial-api/update-video-tutorial';
import { UpdateVideoTutorial$Params } from '../fn/video-tutorial-api/update-video-tutorial';
import { VideoTutorial } from '../models/video-tutorial';

@Injectable({ providedIn: 'root' })
export class VideoTutorialApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateVideoTutorial()` */
  static readonly UpdateVideoTutorialPath = '/v1/api/admin-ui/video-tutorial/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVideoTutorial()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVideoTutorial$Response(params: UpdateVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVideoTutorial>> {
    return updateVideoTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVideoTutorial$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVideoTutorial(params: UpdateVideoTutorial$Params, context?: HttpContext): Observable<ApiResponseVideoTutorial> {
    return this.updateVideoTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVideoTutorial>): ApiResponseVideoTutorial => r.body)
    );
  }

  /** Path part for operation `getListVideoTutorial()` */
  static readonly GetListVideoTutorialPath = '/v1/api/admin-ui/video-tutorial/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListVideoTutorial()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListVideoTutorial$Response(params: GetListVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultVideoTutorial>> {
    return getListVideoTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListVideoTutorial$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getListVideoTutorial(params: GetListVideoTutorial$Params, context?: HttpContext): Observable<ApiResponsePagedResultVideoTutorial> {
    return this.getListVideoTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultVideoTutorial>): ApiResponsePagedResultVideoTutorial => r.body)
    );
  }

  /** Path part for operation `createVideoTutorial()` */
  static readonly CreateVideoTutorialPath = '/v1/api/admin-ui/video-tutorial/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVideoTutorial()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVideoTutorial$Response(params: CreateVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVideoTutorial>> {
    return createVideoTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVideoTutorial$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVideoTutorial(params: CreateVideoTutorial$Params, context?: HttpContext): Observable<ApiResponseVideoTutorial> {
    return this.createVideoTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVideoTutorial>): ApiResponseVideoTutorial => r.body)
    );
  }

  /** Path part for operation `deleteVideoTutorial()` */
  static readonly DeleteVideoTutorialPath = '/v1/api/admin-ui/video-tutorial/delete/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVideoTutorial()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVideoTutorial$Response(params: DeleteVideoTutorial$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoTutorial>> {
    return deleteVideoTutorial(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVideoTutorial$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVideoTutorial(params: DeleteVideoTutorial$Params, context?: HttpContext): Observable<VideoTutorial> {
    return this.deleteVideoTutorial$Response(params, context).pipe(
      map((r: StrictHttpResponse<VideoTutorial>): VideoTutorial => r.body)
    );
  }

}
